module.exports = __webpack_public_path__ + "img/list-task.252b2261.svg";